module.exports = __webpack_public_path__ + "a35ce68bc.png";